import { merge } from 'lodash';
import { PlatformApiEnhancerFunction } from '../../../types/platformApi';
import { canvasOverlayEnhancer } from './canvasOverlayEnhancer';
import { classicDefaultImplementationEnhancer } from './classicDefaultImplementationEnhancer';
import { feedbackEnhancer } from './feedbackEnhancer';
import { pageReplaceEnhancer } from './pageReplace';
import { toolsPanelEnhancer } from './toolsPanel';
import { utilsEnhancer } from './utilsEnhancer';
import { viewStateEnhancer } from './viewState';
import { popupEnhancer } from './popupEnhancer';

export const enhance: PlatformApiEnhancerFunction = (
  platformApiMethods,
  apis,
) => {
  const editorType = window.commonConfig?.host;
  return [
    viewStateEnhancer,
    feedbackEnhancer,
    canvasOverlayEnhancer,
    toolsPanelEnhancer,
    pageReplaceEnhancer,
    utilsEnhancer,
    ...(editorType === 'EDITOR'
      ? [classicDefaultImplementationEnhancer, popupEnhancer]
      : []),
  ].reduce((enhancedPlatformApiMethods, applyEnhancer) => {
    merge(enhancedPlatformApiMethods, applyEnhancer(platformApiMethods, apis));
    return enhancedPlatformApiMethods;
  }, platformApiMethods);
};
